(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 5000px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const body = document.body;
    const openModalTrigger = document.getElementById('settings-button');
    const settingsPopup = document.getElementById('customer_settings_popup');
    const closeModalTrigger = document.getElementById('later');
    //let openedForm;
    //let backInitiator;

    function disableBodyScroll() {
      body.classList.add('no-scroll');
    }

    function enableBodyScroll() {
      body.classList.remove('no-scroll');
    }

    function openModal() {
      //backInitiator = "reset";
      history.pushState('pushed', null, '');
      disableBodyScroll();
      settingsPopup.classList.add('show-popup');
      function handleCloseModalTriggerClick() {
        //backInitiator = 'code';
        window.history.back();
        //console.log('Button was clicked!');
        closeModalTrigger.removeEventListener('click', handleCloseModalTriggerClick);
      }
      /*function handleOpenedFormSubmit() {
          backInitiator = 'code';
          window.history.back();
          console.log('Button2 was clicked!');
          openedForm.removeEventListener('submit', handleOpenedFormSubmit);
        }*/
      //closeModalTrigger.addEventListener('click', handleCloseModalTriggerClick);
      //openedForm.addEventListener('submit', handleOpenedFormSubmit);
    }

    openModalTrigger.addEventListener('click', function () {
      //event.preventDefault(); // Prevent default link/button behavior if applicable
      /*setTimeout(() => {
            openModal();
          }, 100);*/
      openModal();
    });
    function handlePopstate() {
      settingsPopup.classList.remove('show-popup');
      enableBodyScroll();
      //window.removeEventListener('popstate', handlePopstate);
    }
    window.addEventListener('popstate', handlePopstate);
  });

  const deleteAccountBox = document.getElementById('delete-account-box');
  const deleteUnderstand = document.getElementById('delete_account_confirmation_checkbox');
  const delete_button_1 = document.getElementById('account_delete_button_1');
  const delete_button_2 = document.getElementById('account_delete_button_2');
  const account_delete_cancel_button = document.getElementById('account_delete_cancel_button');
  //document.getElementById('first-screen-apple').style.display = 'none';
  //document.getElementById('second-screen').style.display = 'none';

  function toggleShowBox() {
    if (deleteAccountBox.classList.contains('hidden-box')) {
      deleteAccountBox.classList.remove('hidden-box');
    } else {
      deleteAccountBox.classList.add('hidden-box');
    }
  }
  delete_button_1.addEventListener('click', toggleShowBox);
  account_delete_cancel_button.addEventListener('click', toggleShowBox);
  function toggleEnableDelete() {
    // Get the checkbox
    if (deleteUnderstand.checked == true) {
      delete_button_2.classList.remove('disabled-button');
      //delete_button_2.style.opacity = '100%';
      //document.getElementById('delete-button').disabled = false;
    } else {
      delete_button_2.classList.add('disabled-button');
      //delete_button_2.style.opacity = '30%';
      //document.getElementById('delete-button').disabled = true;
    }
  }
  deleteUnderstand.addEventListener('click', toggleEnableDelete);

  function deleteAccount() {
    document.getElementById('deleteText').classList.add('hidden');
    document.getElementById('deleteLoadingSpinner').classList.remove('hidden');

    let url = 'https://webhooks.mechanic.dev/ea3cbc95-375f-4203-9cf3-1f004d41ccd0';
    let xhr = new XMLHttpRequest();
    xhr.open('POST', url);
    xhr.setRequestHeader('Content-Type', 'text/html');
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        document.getElementById('delete_success_box').classList.add('show-success-box');
        history.pushState(null, null, '');
        history.pushState(null, null, '');
        history.pushState(null, null, '');
        history.pushState(null, null, '');
        setTimeout(function () {
          
          // document.getElementById('second-screen').style.display = 'block';
          //document.getElementById('second-screen-apple').style.display = 'none';
          //document.getElementById('apple-instructions-button').style.display = 'none';

          // history.pushState(null, null, '');
          location.assign('/account/logout');
        }, 4000);
      }
    };
    xhr.send(customer_id);
  }
  delete_button_2.addEventListener('click', deleteAccount);
  /*function goBack() {
    history.back();
  }*/

  } catch(e) { console.error(e); }
})();
})();
